import { inject } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { RedirectCommand, ResolveFn, Router } from "@angular/router";
import { CanvasApi } from "../services/canvas-api";
import { PublishedCanvasResult } from "../services/types";

/**
 * Loads a canvas by id before the CanvasViewer component is created.
 * If load fails (404 or network error), navigates to /not-found and halts activation.
 */
export const canvasResolver: ResolveFn<
    PublishedCanvasResult | RedirectCommand
> = async (route): Promise<PublishedCanvasResult | RedirectCommand> => {
    const router = inject(Router);
    const id = route.paramMap.get("canvasId");

    if (!id) {
        // Missing param: redirect immediately
        // create a new redirect command to /not-found
        return new RedirectCommand(router.createUrlTree(["/not-found"]));
    }

    const api = inject(CanvasApi);

    try {
        const result = await api.getCanvas(id);
        return result;
    } catch (e: unknown) {
        if (e instanceof HttpErrorResponse && e.status === 402) {
            return new RedirectCommand(
                router.createUrlTree(["/out-of-units"])
            );
        }

        // On non-402 error, redirect to not-found
        console.error("Error loading canvas, redirecting.", e);
        return new RedirectCommand(router.createUrlTree(["/not-found"]));
    }
};
